import { makeStyles, styled } from "@mui/styles";
import React, { useEffect } from "react";
import { Box, CardActions, CardContent, Divider, Grid, TableCell, tableCellClasses, Typography } from "@mui/material";
import ApexCharts from "react-apexcharts";
import { useTranslation } from "react-i18next";
import bannerBg from "../../assets/images/home/home-banner-bg.svg";
import cssVariables from "../../theme/cssVariables";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#163263',
    },
    [`&.${tableCellClasses.body}`]: {
        'border-width': 0,
        'padding-left': 0,
    },
}));
const styles = {
    paperContainer: {
        backgroundImage: `url(${bannerBg})`,
        width: "100%",
        minHeight: 200,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
    },
    bannerImage: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        maxWidth: "336px",
        height: "auto",
    },
    blueBadge: {
        background: "rgb(186, 217, 87,0.15)",
        padding: "5px 12px",
        color: "#93AC41",
        // opacity: "0.15",
    },
    barLegend: {
        fontSize: "14px",
        lineHeight: "19px",
        color: "#939393",
    }
};
const useStyles = makeStyles({
    media: {
        height: 200,
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    blueBg: {
        background: "#6694CC",
    },
    purpleBg: {
        background: "#7580BD",
    },
    customCardSize: {
        height: 380,
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
        height: "calc(100% - 130px)",
    },
});

function BarLegend(props) {
    // const { data, colors } = props
    const data = props.data;
    // console.log(data)
    let row = [];

    let percent = (data) => {
        let sumpercent = 0
        if (data > 0) {
            sumpercent = ((data / props.totalScore) * 100)
        }
        return sumpercent.toFixed(2)
    }
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));
    if (data.options.labels !== undefined) {
        for (var i = 0; i < data.options.labels.length; i++) {
            row.push(
                <Box key={i} display="flex" alignItems="center" style={{ marginTop: '8px', marginBottom: '8px' }}>
                    <Box sx={{ width: "10%" }} mr="2.5">
                        <div className="bar-legend-square" style={{ backgroundColor: data.options?.colors?.[i] }}></div>
                    </Box>
                    <Box sx={{ width: "50%", overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis" }} px="2.5px">
                        <BootstrapTooltip title={data.options?.labels?.[i]}>
                            <Typography variant="label" style={styles.barLegend} fontWeight={300}> {data.options.labels[i]}</Typography>
                        </BootstrapTooltip>
                    </Box>
                    <Box sx={{ width: "20%", marginLeft: '10px' }} px="2.5px"><Typography variant="label" style={styles.barLegend} fontWeight={500}> {data?.series?.[i] ?? '0'}</Typography></Box>
                    <Box sx={{ width: "20%" }} pl="2.5px"><Typography variant="label" style={styles.barLegend} fontWeight={300}>({data.series[i] ? data?.total > 0 ? parseFloat((data?.series?.[i] / data?.total) * 100).toFixed(1) : '0' : '0'}%)</Typography></Box>
                </Box>
            );
        }
    }
    return (row)
}

const GoalsStatus = (props) => {
    const { t } = useTranslation();
    const { datas, dataPA } = props;
    const classes = useStyles();
    const [typeList, setTypeList] = React.useState([]);
    const [loadApex, setLoadApex] = React.useState(true);

    const [chartObject, setChartObjects] = React.useState({
        type: "donut",
        series: [0],
        options: {
            unit: "คะแนน",
            colors: [
                cssVariables.barChart.donutHomeKpi["100"],
                cssVariables.barChart.donutHomeKpi["200"],
                cssVariables.barChart.donutHomeKpi["300"],
            ],
            states: {
                hover: {
                    filter: {
                        type: 'darken',
                        value: 0.9,
                    }
                },
            },
            labels: ['Planning', 'In Progress', 'Completed'],
            plotOptions: {
                pie: {
                    startAngle: 0,
                    endAngle: 360,
                    expandOnClick: true,
                    offsetX: 0,
                    offsetY: 0,
                    customScale: 1,
                    dataLabels: {
                        offset: 0,
                        minAngleToShowLabel: 10
                    },
                    donut: {
                        size: '70%',
                        background: 'transparent',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                offsetY: 25,
                                formatter: () => t('mygoal.label.complete')
                            },
                            value: {
                                show: true,
                                fontSize: '30px',
                                fontFamily: "Kanit",
                                fontWeight: 600,
                                offsetY: -15,
                                color: '#5DA196',
                                formatter: function (val) {
                                    return val
                                }
                            },
                            total: {
                                show: true,
                                showAlways: true,
                                fontSize: '16px',
                                fontFamily: "Kanit",
                                fontWeight: 300,
                                color: '#A3A3A3',
                                background: "#fff",
                            }
                        }
                    },
                }
            },
            stroke: {
                width: 0,
                colors: ["#fff"],
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                enabled: true,
                enabledOnSeries: undefined,
                shared: true,
                followCursor: false,
                intersect: false,
                inverseOrder: false,
                custom: undefined,
                fillSeriesColor: false,
                theme: false,
                onDatasetHover: {
                    highlightDataSeries: false,
                },
                style: {
                    fontSize: '16px',
                    fontFamily: "Kanit",
                    fontWeight: 300,
                },
                x: {
                    show: true,
                },
                y: {
                    title: {
                        formatter: (seriesName) => seriesName + ":",
                    },
                    style: {
                        fontSize: '16px',
                        fontFamily: "Kanit",
                        fontWeight: 300,
                    },
                    formatter: function (val) {
                        return val;
                    },
                },
                marker: {
                    show: true,
                },
                items: {
                    display: "flex",
                },
                fixed: {
                    enabled: false,
                    position: 'topRight',
                    offsetX: 0,
                    offsetY: 0,
                },
            },
            fill: {
                opacity: 1,
                // type: ['solid', 'gradient'],
                // colors: '#F0F0F0'
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        show: false
                    }
                }
            }],
            legend: {
                show: false,
                position: "right",
                offsetY: 0,
                height: 200,
                // horizontalAlign: "left",
                // offsetX: -33,
                // offsetY: -55,
                formatter: function (val, opts) {
                    const roundToHundred = (arr) => {
                        let output = [];
                        let acc = 0;
                        for (let i = 0; i < arr.length; i++) {
                            let roundedCur = Math.round(arr[i][0]);
                            const currentAcc = acc;
                            if (acc == 0) {
                                output.push(roundedCur);
                                acc += arr[i][0];
                                continue;
                            }
                            acc += arr[i][0];
                            output.push(Math.round(acc) - Math.round(currentAcc));
                        }
                        return output;
                    };
                    let roundedVal = roundToHundred(opts.w.globals.seriesPercent);
                    return (
                        "<span class='fs-12px ml-2'>" +
                        (val ? val : "-") +
                        ":</span><span class='fs-12px fw-600 float-right ml-1'>" +
                        (opts?.w?.globals?.series?.[opts?.seriesIndex] ? opts.w.globals.series[opts.seriesIndex] : 0) +
                        " (" + (roundedVal[opts.seriesIndex] ? parseFloat(roundedVal[opts.seriesIndex]).toFixed(1) : 0) + "%)" +
                        "</span>"
                    );
                },
            },
        },
    });
    const [emptyObject, setEmptyObject] = React.useState({
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false
        },
        colors: ['#F5F5F5'],
        tooltip: {
            enabled: false,
        },
        states: {
            hover: {
                filter: {
                    type: 'none',
                }
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            offsetY: 25,
                            formatter: function (w) {
                                return t('mygoal.label.complete')
                            }
                        },
                        value: {
                            show: true,
                            fontSize: '30px',
                            fontFamily: "Kanit",
                            fontWeight: 600,
                            offsetY: -15,
                            color: '#5DA196',
                        },
                        total: {
                            show: true,
                            showAlways: true,
                            fontSize: '16px',
                            fontFamily: "Kanit",
                            fontWeight: 300,
                            color: '#A3A3A3',
                            background: "#fff",
                            formatter: function (val) {
                                return "0%"
                            }
                        },
                        style: {
                            fontFamily: 'Kanit',
                        }
                    }
                }
            }
        }
    })
    const [emptySeries, setEmptySeries] = React.useState([1])

    const mapping = (chart, datas) => {
        var chartData = JSON.parse(JSON.stringify(chart))
        if (datas) {
            if (datas?.value?.some((item) => Number(item) != 0)) {
                chartData = {
                    ...chartData,
                    series: datas?.value ?? [1],
                    options: {
                        ...chartData.options,
                        labels: datas?.name ?? [""],
                        colors: datas?.colors ?? [""]
                    },
                    total: datas?.total ?? 0,
                }
                const percent = datas.value[datas.value.length - 1] > 0 ? parseFloat(datas.value[datas.value.length - 1] / datas.total) * 100 : 0
                chartData.options.plotOptions.pie.donut.labels.total.formatter = (w) => {
                    return `${(percent > 0) ? parseFloat(percent).toFixed(1) : 0}%`
                }
            }
            if (datas?.value?.every((item) => Number(item) == 0) || datas?.value == null) {
                chartData.series = [0]
                chartData.options.labels = datas.name
                chartData.options.fill.colors = '#F5F5F5'
                chartData.options.colors = datas.colors
            }
        }
        return chartData
    }

    useEffect(() => {
        if (datas) setChartObjects(mapping(chartObject, datas))
    }, [datas])

    return (
        <Box px={2} pt={1}>
            <CardContent className={classes.cardContentSize} sx={{ justifyContent: "flex-start", alignItems: "flex-start", padding: "10px 0 0 0" }}>
                {/* <Box>
                      <img src={fileBrowser} alt="browser" />
                    </Box>
                    <Box>
                      <Typography>{t("home.label.nodata")}</Typography>
                    </Box> */}
                <Grid container mb={2}>
                    <Grid item cols="auto">
                        <Typography fontSize={18} lineHeight="26.4px" fontWeight={500} color="#404349" sx={{ textAlign: "left" }}>
                            {t("mygoal.label.goalProgress")}
                        </Typography>
                    </Grid>
                </Grid>
                <Box display="flex" alignItems="center" width="100%" >
                    <Box sx={{ "margin-left": "-10px", ".apexcharts-tooltip-y-group > span": { "font-weight": "400" }, ".apexcharts-active": { background: "#F7F7F7", "padding-bottom": "0px", "box-shadow": "0px 2px 4px rgba(0, 0, 0, 0.15)", ".apexcharts-tooltip-marker": { "border-radius": "unset", "border-radius": "2px" } }, ".apexcharts-graphical": { transform: "unset" } }}>
                        {
                            (datas?.value?.some((item) => Number(item) != 0)
                                ?
                                <>
                                    <ApexCharts
                                        style={{ width: "280px", height: "210px" }}
                                        options={chartObject?.options ?? emptyObject}
                                        series={chartObject?.series ?? [0]}
                                        type="donut"
                                    />
                                </>
                                :
                                <>
                                    <ApexCharts
                                        style={{ width: "280px", height: "210px" }}
                                        options={emptyObject}
                                        series={emptySeries}
                                        type="donut"
                                    />
                                </>
                            )
                        }
                    </Box>
                    <Box sx={{ width: "calc(100% - 280px)" }}>
                        <Box sx={{ "margin-left": "-10px", width: "calc(100% + 15px)" }}>
                            <Box item lg={12} xs={12}>
                                <BarLegend data={chartObject}></BarLegend>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </CardContent >
        </Box >
    )
}

export default GoalsStatus
